var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsbWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.4 5c-.3 0-.5-.2-.5-.5v-2c0-.3-.2-.5-.5-.5h-2.9c-.2 0-.4.3-.4.5v2c0 .3-.2.5-.5.5s-.6-.2-.6-.5v-2c0-.8.7-1.5 1.5-1.5h2.9c.9 0 1.6.7 1.6 1.5v2c0 .3-.3.5-.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2 15h-6.4c-.7 0-1.3-.6-1.3-1.3v-6.5c0-.7.6-1.3 1.3-1.3h6.3c.7 0 1.3.6 1.3 1.3v6.5c.1.7-.5 1.3-1.2 1.3m-6.4-7.6v6c0 .2.1.3.3.3h5.8c.2 0 .3-.1.3-.3v-6c0-.2-.1-.3-.3-.3h-5.8c-.1 0-.3.2-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2 5c-.3 0-.5-.2-.5-.5v-1.5c0-.3.2-.5.5-.5s.5.2.5.5v1.4c0 .4-.2.6-.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.8 5c-.3 0-.5-.2-.5-.5v-1.5c0-.3.2-.5.5-.5s.5.2.5.5v1.4c0 .4-.2.6-.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 19c-.4 0-.7-.3-.7-.7v-3.2h1.4v3.2c0 .4-.3.7-.7.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6 12.8h-3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h3.2c.4 0 .7.3.7.7s-.3.7-.7.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbWhite);
export default __webpack_public_path__ + "static/media/usb-white.993ea2049904ba32372448a09a8b8f82.svg";
export { ForwardRef as ReactComponent };